import React from 'react'

import {removeZeros} from '../../../utils/misc'

export default class SellingBasicRate extends React.Component {
  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

handleChange(e) {
  let item = this.props.item, key= e.target.name, value=e.target.value

  item[key]= (value)

  this.props.onChangeCallback(item)
}

  render(){

    let is_composition = (typeof this.props.is_composition !== "undefined" && this.props.is_composition) ? true : false


    let val = (is_composition? this.props.item.selling_rate : this.props.item.selling_basic_rate)
    if(val > 0) {
      val = removeZeros(val)
    }
    if(is_composition) {
      return <input type="text" name="selling_rate" className="form-control input-sm" onChange={this.handleChange} value={val}  />
    }
    else {
        return <input type="text" name="selling_basic_rate" className="form-control input-sm" onChange={this.handleChange} value={val}  />
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/sellingbasicrate.js